import {useEffect, useState} from "react";
import './index.scss'
import {newQuotation} from "../../api/quotationApiClient";
import {findScenario} from "../../api/scenarioApiClient";
import {Scenario} from "../../api/model/scenario";
import {createTheme, ThemeProvider} from "@material-ui/core";
import {strings} from "../../strings/strings";
import {ErrorMessageDialog} from "../../components/dialogs/ErrorMessageDialog";
import {ErrorDialogType} from "../../utils/hooks/useErrorDialog";
import {TravelHeader} from "../../components/TravelScenario/Header";
import {TravelQuotationContext} from "../../contexts/TravelQuotationContext";
import {TravelScenarioComponent} from "../../components/TravelScenario";
import TravelQuotationCardContextProvider from '../../contexts/TravelQuotationCardContext';
import {ProductType} from "../../api/model/common";
import { Select } from "../../components/TravelScenario/Select";
import { InfoView } from "../../components/InfoView/infoView";
import { useCheckingForMemorizing } from "../../utils/hooks/memorizeMethods";
import { useHotjar } from "../../utils/hooks/useHotjar";

export const QuotationTravelForm = ({salesVariant, scenarioCode}) => {
    const [isLoading, setLoading] = useState(true);
    const [quotation, setQuotation] = useState(null);
    const [packages, setPackages] = useState([])
    const [currentStep, setCurrentStep] = useState<string | null>(null)
    const [currentScenario, setCurrentScenario] = useState<Scenario>(null);
    const [openErrorMessageDialog, setOpenErrorMessageDialog] = useState(false);
    const [agree1Checkbox, setAgree1Checkbox] = useState(false);
    const [agreeInformCheckbox, setAgreeInformCheckbox] = useState(false);
    const [payerIsPersonCheckbox, setIsPayerIsPersonCheckbox] = useState<boolean>(true);
    const [tariffied, setTariffied] = useState(false);
    const [tab, setTab] = useState("firstTime");
    const [hideHeader, setHideHeader] = useState(false);
    const [foundPrimaryInsured, setFoundPrimaryInsured] = useState(null);
    const [isQuotationEditable, setIsQuotationEditable] = useState(true);

    const { trackHotjar } = useHotjar()

    useEffect(() => {
        trackHotjar("", "travel")
    }, [])

    const theme = createTheme({
        palette: {
            secondary: {
                main: '#EF533F'
            }
        }
    });

    const rememberAll = async () => {
        const memorizedStep = localStorage.getItem("TRAVEL_step")
        const memorizedQuotation = JSON.parse(localStorage.getItem("TRAVEL_quotation"))
        const packages = JSON.parse(localStorage.getItem('TRAVEL_packages') || "[]")
        const tariffied = localStorage.getItem("TRAVEL_tariffied") === 'true'
        const scenario = await findScenario(scenarioCode)
        setQuotation(memorizedQuotation)
        setCurrentScenario(scenario);
        setCurrentStep(memorizedStep)
        setPackages(packages)
        if(memorizedStep === "travel_online_00002"){
            setIsPayerIsPersonCheckbox(memorizedQuotation.payerIsPerson)
        }
        setTariffied(tariffied)
        setLoading(false);
    }

    const fetchData = async () => {
        const fetchedQuotation = await newQuotation(salesVariant, scenarioCode, ProductType.TRAVEL)
        fetchedQuotation.travelWebContract.touristCount = 1
        setQuotation(fetchedQuotation);
        setCurrentScenario(await findScenario(scenarioCode));
        setLoading(false);
    }

    useCheckingForMemorizing(ProductType.TRAVEL, fetchData, rememberAll, () => setOpenErrorMessageDialog(true))

    useEffect(() => {
        if( quotation ){
            localStorage.setItem("TRAVEL_quotation", JSON.stringify(quotation))
            localStorage.setItem("TRAVEL_tariffied", tariffied ? 'true' : 'false')
            if( packages.length > 0 ){
                localStorage.setItem("TRAVEL_packages", JSON.stringify(packages))
            }
        }
    }, [currentStep, quotation, tariffied, packages])

    useEffect(() => {
        if( quotation){
            setQuotation(quotation => ({...quotation, currentStep}))
        }
    }, [currentStep])

    return (
        <div className={'travel-wrapper'}>

            <ErrorMessageDialog type={ErrorDialogType.ERROR}
                                text={strings.errorDefaultMessage}
                                open={openErrorMessageDialog}
                                onClickListener={() => setOpenErrorMessageDialog(false)}/>
            {isLoading ? (
                <></>
             ) : (
                <ThemeProvider theme={theme}>
                    <TravelQuotationContext.Provider value={{
                        quotation,
                        type: ProductType.TRAVEL,
                        setQuotation,
                        packages,
                        setPackages,
                        agree1Checkbox,
                        setAgree1Checkbox,
                        agreeInformCheckbox,
                        setAgreeInformCheckbox,
                        currentStep,
                        setCurrentStep,
                        tariffied,
                        setTariffied,
                        payerIsPersonCheckbox,
                        setIsPayerIsPersonCheckbox,
                        tab,
                        setOpenErrorMessageDialog,
                        setTab,
                        foundPrimaryInsured,
                        setFoundPrimaryInsured,
                        isQuotationEditable,
                        setIsQuotationEditable
                    }}>
                             <TravelQuotationCardContextProvider>
                                <>
                                    {currentStep !== 'travel_online_00003' ? <TravelHeader/> : <></>}
                                    
                                    <div className={`${currentStep !== 'travel_online_00003' ? 'travel-wrapper__content' : 'travel-wrapper__content_verification'}`}>
                                        { !hideHeader && !tariffied && <Select 
                                            items={[{ 
                                                value:"firstTime", label: strings.toolbarNewClient
                                            },{
                                                value:"imClient", label: <>{strings.toolbarARXClient} <InfoView orangeText={`${strings.travel.header.name.toLowerCase()} `}/></>
                                            }]}
                                            defaultValue={tab}
                                            onValueSelect={(val) => setTab(val)}
                                        /> }
                                        <TravelScenarioComponent scenario={currentScenario} onCustomerFound={() => setHideHeader(true)}/>
                                    </div>
                                </>
                             </TravelQuotationCardContextProvider>
                    </TravelQuotationContext.Provider>
                </ThemeProvider>
            )}
        </div>
    )
};

